module.exports = __webpack_public_path__ + "static/media/settings_icon.064898ac.svg";